import { render, staticRenderFns } from "./alarmDetails.vue?vue&type=template&id=6c2b44da&"
import script from "./alarmDetails.vue?vue&type=script&lang=js&"
export * from "./alarmDetails.vue?vue&type=script&lang=js&"
import style0 from "./alarmDetails.vue?vue&type=style&index=0&id=6c2b44da&prod&lang=scss&"
import style1 from "./alarmDetails.vue?vue&type=style&index=1&id=6c2b44da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports